import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function RewindIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13 13.2V20L3 11.5L13 4V10L21 4V20L13 13.2Z",
    fill: "currentColor"
  }));
}